<template>
  <!-- <div class="d-flex "> -->
  <div class="card col-12 p-0 shadow">
    <!-- <p class="fs-4 fw-bold">Select Factors</p> -->
    <div class="card-body">
      <!-- <div class="d-flex col-12 p-0">
                    <div class="d-flex flex-column col-6 px-0">
                        
                        <select class="form-control" @input="selectSelectedCharge">
                            <option v-for="(charge, index) in charges" :value="index" :selected="index == selectedCharge" :key="charge.Id">{{ charge.CountNumber }}. {{ charge.codeDefinitionCode }} {{ charge.statuteDefinitionSection }}</option>
                        </select>
                    </div>
                </div> -->
      <p class="fw-bold fs-5">{{ prompt }}</p>
      <div class="d-flex flex-column" v-if="factors.length > 0">
        <div class="d-flex" v-for="(factor, index) in factors" :key="factor.Id">
          <input type="radio" :id="`cpk${factor.FactorId}`" :value="index" v-model="selectedFactor" />
          <label class="ml-4 fs-5" :for="`cpk${factor.FactorId}`">{{ factor.FactorName }}</label>
        </div>
        <div style="text-align: center" class="mt-3">
          <button class="btn btn-primary btn btn-xl" @click="addCrimeToCharges(foundCrime)">Replace</button>
        </div>
      </div>
      <div v-else>
        <p>This charge has no relevant factors</p>
      </div>
    </div>
  </div>
  <!-- <div class="card col-6 p-0 mx-2 shadow" v-if="foundCrime !== null">
            
            <div class="card-header fs-5 fw-bold pt-2 pb-0 pl-3">
                <p class="m-0">Add Charge to Case</p>
                
            </div>
            <div class="card-body">
                <p class="my-3">Replace</p>
                <h4 class="fs-8">{{charges[selectedCharge].Name }}</h4>
                <p class="my-3">- With -</p>
                <h4 class="fs-8 mb-3">{{foundCrime?.Name}} ({{ foundCrime.crmSeverityName }}) </h4>
                <button class="btn btn-primary" @click="addCrimeToCharges(foundCrime)">Replace</button>
                
            </div>
        </div> -->
  <!-- </div> -->
</template>
<script>
import axios from "axios";
import SC from "../../../components/utils/sharedComponent.vue";
export default {
  name: "CPKSelector",
  props: ["charges", "user_token", "caseId", "selectedChg"],
  data() {
    return {
      selectedCharge: this.key,
      factors: [],
      CPKGroupId: null,
      selectedFactor: null,
      foundCrime: null,
      prompt: null,
    };
  },
  methods: {
    async getFactors(charge) {
      this.selectedFactor = null;
      // console.log("GETS FACTORS");
      // console.log(this.charges[this.selectedCharge]);
      if (charge?.Id) {
        const token = localStorage.getItem("user_token");
        // let body = {
        //   field: "*",
        //   table: "VCrimeCPKGroup",
        //   condition: `CrimeId = ${
        //     charge.ChargedPer ? charge.ChargedPer : charge.CrimeId
        //   } AND Legacy IS NULL`,
        // };
        const crimeId = charge?.ChargedPer ?? charge?.CrimeId
        const cpkId = await axios
          .get(process.env.VUE_APP_ENDPOINT + "/api/vCrimeCPKGroup/getManyByCrimeId/" + crimeId, {
            headers: { Authorization: `Bearer ` + token },
          })
          .then(async (results) => {
            // console.log("CPK GROUP", results);
            if (results?.data?.length > 0) {
              this.prompt = results?.data[0].PromptMessage;
              this.CPKGroupId = results?.data[0].CPKGroupId;

              const foundFactors = await axios
                .get(process.env.VUE_APP_ENDPOINT + "/api/crimeFactorCPKGroup/getManyByCPKGroupId/" + this.CPKGroupId, {
                  headers: { Authorization: `Bearer ` + token },
                })
                .then((result) => {
                  // console.log("CrimeFactors", result);
                  this.factors = _.orderBy(result.data, ["SortValue", "asc"]);
                  const factorIndex = this.factors.findIndex((factor) => {
                    // console.log(
                    //   factor.CrimeId == this.charges[this.selectedCharge].CrimeId
                    // );
                    return factor.CrimeId == this.charges[this.selectedCharge].CrimeId;
                  });
                  // console.log(factorIndex);
                  if (factorIndex !== -1) {
                    this.selectedFactor = factorIndex;
                  } else {
                    this.selectedFactor = null;
                  }
                  this.selectedFactor;
                  // console.log(this.selectedFactor);
                  // console.log("this.factors:::", this.factors);
                });
            } else {
              // console.log(results);
              this.factors = [];
              this.selectedFactor = null;
            }
          });
        return cpkId;
      }
    },
    async addCrimeToCharges(crime) {
      // console.log(this.charges[this.selectedCharge]);
      // console.log(crime);
      const token = localStorage.getItem("user_token");
      const replacedCharge = await SC.replaceCharge(this.charges[this.selectedCharge], crime, token).then((result) => {
        // console.log(result);
      });
      this.$emit("refreshCharges");
    },
    selectSelectedCharge(event) {
      // console.log(event.target.value);
      this.$emit("emitSelectCharge", event.target.value);
      this.selectedCharge = event.target.value;
      this.getFactors(this.charges[event.target.value]);
    },
  },
  watch: {
    // selectedCharge: function(val, oldVal) {
    //     const activeCharge = this.charges[val];

    // },
    selectedFactor: async function (val, oldVal) {
      if (val !== null) {
        const token = localStorage.getItem("user_token");

        const foundCrime = await axios
          .get(process.env.VUE_APP_ENDPOINT + "/api/crimes/" + this.factors[this.selectedFactor]?.CrimeId, {
            headers: { Authorization: `Bearer ` + token },
          })
          .then((result) => {
            if (result.data?.Id) {
              this.foundCrime = result.data;
            }
          });
      }
    },
  },
  async beforeMount() {
    this.selectedCharge = this.selectedChg;
    // console.log("SELECTED CHARGE", this.selectedCharge);
    // console.log(this.charges);
    if (this.charges?.length) {
      const activeCharge = this.charges[this.selectedCharge];
      await this.getFactors(activeCharge);
    }
  },
};
</script>
